<template>
  <div class="content d-flex-right">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader :items="['type_id','place_id','region_id','project_id']" @onHeader="onHeader" />
        </div>
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="近12月统计" name="12month">
          <LawsuitOverviewStatisticsMonth v-if="card_index==='12month'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="近30日统计" name="30day">
          <LawsuitOverviewStatisticsDay v-if="card_index==='30day'" />
        </el-tab-pane>
<!--        <el-tab-pane label="当月完成率" name="dywcl">-->
<!--          <LawsuitOverviewCompletionRate v-if="card_index==='dywcl'" />-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="月度完成率统计" name="ydwcl">
          <LawsuitOverviewCompletionRateYearMonth v-if="card_index==='ydwcl'" />
        </el-tab-pane>
        <el-tab-pane label="当月完成率统计表" name="MonthlyCompletionRate">
          <MonthlyCompletionRate  v-if="card_index==='MonthlyCompletionRate'" />
        </el-tab-pane>
        <el-tab-pane label="月度账龄统计表" name="MonthlyAgingStatisticsTable">
          <MonthlyAgingStatisticsTable  v-if="card_index==='MonthlyAgingStatisticsTable'" />
        </el-tab-pane>
        <el-tab-pane label="月度诉讼统计表" name="MonthlyLitigationStatisticsTable">
          <MonthlyLitigationStatisticsTable  v-if="card_index==='MonthlyLitigationStatisticsTable'" />
        </el-tab-pane>
        <el-tab-pane label="立案率及回款统计表" name="RecordFilingRateAndCollectionStatisticsTable">
          <RecordFilingRateAndCollectionStatisticsTable  v-if="card_index==='RecordFilingRateAndCollectionStatisticsTable'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";

import AgingType from "./components/common/AgingType";
import LawsuitOverviewStatisticsMonth from "./components/lawsuit_overview/LawsuitOverviewStatisticsMonth";
import LawsuitOverviewStatisticsDay from "./components/lawsuit_overview/LawsuitOverviewStatisticsDay";
import LawsuitOverviewCompletionRate from "./components/lawsuit_overview/LawsuitOverviewCompletionRate";
import LawsuitOverviewCompletionRateYearMonth
  from "./components/lawsuit_overview/LawsuitOverviewCompletionRateYearMonth";
import MonthlyCompletionRate from "./components/report_forms/MonthlyCompletionRate";
import MonthlyAgingStatisticsTable from "./components/report_forms/MonthlyAgingStatisticsTable";
import MonthlyLitigationStatisticsTable from "./components/report_forms/MonthlyLitigationStatisticsTable";
import RecordFilingRateAndCollectionStatisticsTable
  from "./components/report_forms/RecordFilingRateAndCollectionStatisticsTable";
import ButlerHttp from "./common/ButlerHttp";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "LawsuitOverview",
  components: {
    SelectCdjProjectHeader,
    RecordFilingRateAndCollectionStatisticsTable,
    MonthlyLitigationStatisticsTable,
    MonthlyAgingStatisticsTable,
    MonthlyCompletionRate,
    LawsuitOverviewCompletionRateYearMonth,
    LawsuitOverviewCompletionRate,
    LawsuitOverviewStatisticsDay,
    LawsuitOverviewStatisticsMonth,
    AgingType,

  },
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data(){
    return{
      is_loading:false,
      where: {
        text:"",
        is_authentication:"",
        thrid_company_id:"",
        start_time:moment(new Date()).format("YYYY-MM"),
        end_time:moment(new Date()).format("YYYY-MM"),
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_region_level:"",
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        age:"",
        level:0
      },
      card_index:"12month",
      thrid_company_list:[]
    }
  },
  activated() {
    const that=this;
    that.getThridCompanyList()
    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods:{
    getThridCompanyList(){
      const that = this;
      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyList", {
        status: 1,
        page: 1,
        page_size: 300
      }, res => {
        if (res.code) {
          that.thrid_company_list = res.data.list;
        }
      });
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LawsuitOverview.vue